"use client";

import React, { useState } from "react";
import styles from "./StatsSectionCareer.module.scss";
import cn from "clsx";
import "swiper/css";
import { statCards } from "../utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  showDivider?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  description,
  showDivider,
}) => (
  <div className={cn(styles.statCard, showDivider && styles.rightCard)}>
    <div className={styles.line} />
    <div className={styles.statIcon}>{icon}</div>
    <div className="flex flex-col items-start">
      <h3 className={styles.statTitle}>{title}</h3>
      <p className={styles.statDescription}>{description}</p>
    </div>
  </div>
);
const StatsSection: React.FC = () => (
  <div className={styles.statsGrid}>
    {statCards.map((card, index) => {
      return (
        <StatCard
          key={index}
          icon={card.icon}
          title={card.title}
          description={card.description}
          // showDivider={index !== statCards.length - 1}
        />
      );
    })}
  </div>
);

const StatsSectionCareer = ({ isHaridwar = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className={styles.statsContainer}>
      <div className={styles.statsContainerDweb}>
        <StatsSection />
      </div>
      <div className={styles.statsContainerMobile}>
        <Swiper
          modules={[Autoplay]}
          slidesPerView={2}
          spaceBetween={0}
          loop={false}
          speed={400}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        >
          {statCards.map((card, index) => {
            const isRightCard = index === activeIndex + 1;
            return (
              <SwiperSlide key={index}>
                <StatCard
                  key={index}
                  icon={card.icon}
                  title={card.title}
                  description={card.description}
                  showDivider={isRightCard}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default StatsSectionCareer;
